// StudyAbroadIntro.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const StudyAbroadIntro = () => {
  const considerations = [
    'Understanding entry requirements and academic fit',
    'Choosing suitable countries, institutions, and programs',
    'Preparing strong applications and personal statements',
    'Managing application timelines and follow ups',
    'Making informed financial and relocation decisions'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side - Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356]">
              What Studying Abroad Really Involves
            </h2>
          </motion.div>
          
          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              Studying abroad goes beyond choosing a country or university. It requires careful planning, eligibility assessment, strong documentation, and an understanding of timelines and expectations.
            </p>
            
            <p className="text-gray-600 text-sm font-semibold mb-4">
              A successful study abroad journey typically involves:
            </p>
            
            <ul className="space-y-3">
              {considerations.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle size={16} className="text-gray-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 text-sm font-light">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StudyAbroadIntro;
